module.exports = __webpack_public_path__ + "img/1F63C.54421a9d.svg";